import React, { Component } from "react";
import { Row } from "reactstrap";
import Chart from "react-google-charts";
import { connect } from "react-redux";
import Axios from "axios";
import { withStyles } from "@material-ui/core/styles";

import ContentWrapper from "../../template/Layout/ContentWrapper";
import VectorMap from "./components/Maps/VectorMap";
import CardsTotals from "./components/CardTotals";
import { Autocomplete, TextField } from "@mui/material";

import { FullLoader } from "./components/Loader";
import { TableLoader as ShipmentMap } from "./components/Loader";
import Loader from "../../Global/Loader";
import { Services } from "../../../repositories/clients/Services";
import "./styles.scss";
import paises from "./components/Maps/paises.json";
import { ResponsivePie } from "@nivo/pie";

import { light_blue, cool_blue, neutral_grey, PRIMARY_COLOR } from "../../../utils/colors";

import { withNamespaces } from "react-i18next";
import SessionStorage from "../../../services/SessionStorage";

const session = new SessionStorage();

/**
 * @markerColor : the marker points
 * @bgColor : the background
 * @scaleColors : the color of the region in the serie
 * @regionFill : the base region color
 */

const useStyles = (theme) => ({
  textfield: {
    "& .MuiInputBase-input.MuiAutocomplete-input": {
      fontSize: 12,
      color: "#000a2e",
    },
  },
  datefield: {
    "& .MuiInput-input.MuiInputBase-input": {
      fontSize: 12,
      color: "#000a2e",
    },
  },
  searchLabel: {
    fontSize: 12,
    color: "#000a2e",
  },
  euroDateField: {
    "& .MuiCalendarPicker-root": {
      fontSize: 12,
      color: "#000a2e",
    },
  },
  popupIndicator: {
    "& path": {
      d: "path('M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z')",
    },
  },
  popupIndicatorOpen: {
    "& path": {
      d: "path('M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z')",
    },
  },
});

const defaultColors = {
  markerColor: "#0561fc",
  bgColor: "transparent",
  scaleColors: ["#0561fc"],
  regionFill: "#9D9D9C",
};

const chartOptions = {
  width: "100%",
  height: "300px",
  chartArea: {
    width: "75%",
  },
  tooltip: { isHtml: true },
  legend: {
    position: "none",
  },
  animation: {
    startup: true,
    easing: "linear",
    duration: 1000,
  },
  hAxis: {
    textStyle: {
      fontSize: 12,
      color: "#000a2e",
      fontName: "SF Pro Display",
    },
  },
  vAxis: {
    textStyle: {
      fontSize: 12,
      color: "#000a2e",
      fontName: "SF Pro Display",
    },
  },
};
const chartOptionsLine = {
  width: "100%",
  height: "300px",
  chartArea: {
    width: "80%",
  },
  curveType: "function",
  legend: { position: "none" },
  tooltip: { isHtml: true },
  vAxis: {
    minValue: 0,
    viewWindow: { min: 0 },
    textStyle: {
      fontSize: 12,
      color: "#000a2e",
      fontName: "SF Pro Display",
    },
  },
  hAxis: {
    textStyle: {
      fontSize: 12,
      color: "#000a2e",
      fontName: "SF Pro Display",
    },
  },
  pointSize: 5,
  series: {
    0: {
      color: "#000a2e",
      lineWidth: 2,
    },
  },
};

const cardTooltipStyle = {
  border: "1px #000a2e solid",
  backgroundColor: "#fff",
  height: "30px",
  display: "flex",
  alignItems: "center",
};

const legendSettings = {
  anchor: "center",
  direction: "column",
  translateX: 185,
  translateY: 0,
  itemsSpacing: 10,
  itemWidth: 100,
  itemHeight: 18,
  itemTextColor: "#999",
  itemDirection: "left-to-right",
  itemOpacity: 1,
  symbolSize: 18,
  symbolShape: "circle",
  effects: [
    {
      on: "hover",
      style: {
        itemTextColor: "#000",
      },
    },
  ],
};
/*=============================================
=            Dashboard Component              =
=============================================*/
class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      titleShipmentForCountry: "",
      MapShipmentCountry: <></>,
      shipmentForCountrySelected: 1,
      userId: props._user,
      language: props.lng,
      optionShipmentForCountry: [
        { label: props.t("origin"), text: props.t("origin"), value: 1 },
        {
          label: props.t("destination"),
          text: props.t("destination"),
          value: 2,
        },
      ],
      optionShipmentDefault: {
        label: props.t("origin"),
        text: props.t("origin"),
        value: 1,
      },
      text: "",
      ModoTransporte: {},
      colors: [PRIMARY_COLOR, cool_blue, light_blue, neutral_grey],
      isMovil: false,
      totales: {
        PedidosActivos: 0,
        EmbarquesActivos: 0,
        ConsolidadosActivos: 0,
        EmbarquesPrioritarios: 0,
      },
      flat: false,
      tendenciaData: [],
      maxTendencia: 0,
      tendenciaOptions: {
        series: {
          lines: {
            show: false,
          },
          points: {
            show: true,
            radius: 4,
          },
          splines: {
            show: true,
            tension: 0.4,
            lineWidth: 1,
            fill: 0.5,
          },
        },
        grid: {
          borderColor: "#eee",
          borderWidth: 1,
          hoverable: true,
          backgroundColor: "#fcfcfc",
        },
        tooltip: true,
        tooltipOpts: {
          content: (label, x, y) => x + " : " + y,
        },
        xaxis: {
          tickColor: "#fcfcfc",
          mode: "categories",
        },
        yaxis: {
          min: 0,
          tickColor: "#eee",
          autoscaleMargin: 0.5,
          tickDecimals: 0,
          tickFormatter: (v) => v,
        },
        shadowSize: 0,
      },
      Attention: [],
      estatusEmbarques: [],
      Map: [],
      loadingTrends: true,
      loadingTotals: true,
      loadingShiptmenMap: true,
      RegionValues: {},
      fullLoader: false,
      markers: [],
      markersValue: [],
    };
  }
  /*=============================================
  =            Get Info Dashboard Function      =
  =============================================*/
  getInfoDashBoard = async () => {
    let {
      totales,
      estatusEmbarques,
      markers,
      markersValue,
      RegionValues,
      userId,
      shipmentForCountrySelected,
      language,
    } = this.state;
    //############ INVOCACION COMENTADA ##############
    let data = {
      shipmentForCountrySelected: shipmentForCountrySelected,
      userId: Number(userId),
      language: language,
      Entities:
        this.props.clients.length > 0
          ? JSON.stringify(this.props.clients)
          : "[0]",
      userId: this.props._user,
      lang: language,
    };
    let response = await Axios.post(
      `${Services.DASHBOARD.path}dashboard/total`,
      data
    );

    response.data.data.ModoTransporte.data.sort((a, b) =>
      a.id.localeCompare(b.id)
    );

    if (response.status === 200) {
      totales = this.obtieneTotales(response.data.data);
      estatusEmbarques = this.obtieneEstatusEmbarques(response.data.data);
      await this.obtieneEventosAtencion(response.data.data.EventosAtencion);
      await this.obtieneTendenciasEmbarques(response.data.data.Tendencia);
      markersValue = response.data.data.regionValues;
      markers = this.obtieneMarkers(
        response.data.data.regionValues,
        response.data.data.Mapdata
      );
      RegionValues = this.obtieneRegionValues(response.data.data.regionValues);
    }

    let NewMap = (
      <VectorMap
        options={{
          map: "world_mill_en",
          markersSelectable: true,
          backgroundColor: defaultColors.bgColor,
          zoomMin: 1,
          zoomMax: 8,
          zoomOnScroll: false,
          regionStyle: {
            initial: {
              fill: defaultColors.regionFill,
              "fill-opacity": 1,
              stroke: "none",
              "stroke-width": 1.5,
              "stroke-opacity": 1,
            },
            hover: {
              //fill: '#020E3A',
              fillOpacity: 0.8,
            },
            selected: {
              fill: "#000a2e",
            },
            selectedHover: {
              fill: "#000a2e",
              fillOpacity: 0.8,
            },
          },
          focusOn: {
            x: 0.4,
            y: 0.6,
            scale: 1,
          },
          markerStyle: {
            initial: {
              fill: defaultColors.markerColor,
              fillOpacity: 1,
            },
          },
          onRegionLabelShow: (e, el, code) => {
            paises.countries.map((pais) => {
              if (pais.code === code) {
                el.html(language === "US" ? pais.name_en : pais.name_es);
              }
            });
            markersValue.map((mark) => {
              if (mark.PaisId === code) {
                el.html(
                  el.html() +
                    ": " +
                    mark.total +
                    " " +
                    this.props.t("shipments")
                );
              }
            });
          },
          // onRegionOver: (e, code) => {
          //   e.preventDefault();
          // },
          // // onMarkerSelected: this.handleMarkerClick,
          // onMarkerLabelShow: (e, el, code) => {
          //   e.preventDefault();
          // },
        }}
        series={{
          regions: [
            {
              values: RegionValues,
              scale: defaultColors.scaleColors,
              normalizeFunction: "polynomial",
            },
          ],
        }}
        // markers={markers}
        markers={[]}
      />
    );

    this.setState({
      ModoTransporte: response.data.data.ModoTransporte,
      titleShipmentForCountry: response.data.data.titleShipmentForCountry,
      estatusEmbarques,
      totales,
      loadingTotals: false,
      loadingTrends: false,
      loadingShiptmenMap: false,
      fullLoader: true,
      MapShipmentCountry: NewMap,
      // markers,
      // markersValue,
      // RegionValues,
    });
  };

  obtieneRegionValues = (regionValues) => {
    var arrayValues = [];
    regionValues.map((region) => {
      arrayValues[region.PaisId] = Number(region.total);
    });
    return arrayValues;
  };

  obtieneValorMarkers = (regionValues) => {
    var codeValues = [];
    var values = [];
    var keys = [];
    regionValues.forEach((element) => {
      if (codeValues.length === 0 || keys.indexOf(element.POD) < 0) {
        codeValues.push({ total: 1, code: element.POD });
        keys.push(element.POD);
      } else {
        var index = codeValues.findIndex((code) => code.code === element.POD);

        codeValues[index].total = codeValues[index].total + 1;
      }
    });

    return codeValues;
  };

  obtieneMarkers = (markersVaues, markers) => {
    var orderedMarker = [];
    markersVaues.forEach((element) => {
      var mark = markers.filter((marker) => marker.name === element.name);
      orderedMarker.push(mark ? mark[0] : null);
    });
    return orderedMarker;
  };

  handleChangeDrop = (attribute) => (evt, data) => {
    let shipmentForCountrySelected = data.value;

    this.setState(
      {
        shipmentForCountrySelected,
        loadingShiptmenMap: true,
      },
      () => this.getDataMapShipments()
    );
  };

  getDataMapShipments = async () => {
    try {
      let {
        markers,
        markersValue,
        RegionValues,
        userId,
        shipmentForCountrySelected,
        language,
      } = this.state;
      let data = {
        shipmentForCountrySelected: shipmentForCountrySelected,
        userId: Number(userId),
        language: language,
        Entities:
          this.props.clients.length > 0
            ? JSON.stringify(this.props.clients)
            : "[0]",
      };

      let response = await Axios.post(
        `${Services.DASHBOARD.path}dashboard/getMapData`,
        data
      );
      if (response.status === 200) {
        markersValue = response.data.data.regionValues;
        markers = this.obtieneMarkers(
          response.data.data.regionValues,
          response.data.data.Mapdata
        );
        RegionValues = this.obtieneRegionValues(
          response.data.data.regionValues
        );
      }
      let NewMap = (
        <VectorMap
          options={{
            map: "world_mill_en",
            markersSelectable: true,
            backgroundColor: defaultColors.bgColor,
            zoomMin: 1,
            zoomMax: 8,
            zoomOnScroll: false,
            regionStyle: {
              initial: {
                fill: defaultColors.regionFill,
                "fill-opacity": 1,
                stroke: "none",
                "stroke-width": 1.5,
                "stroke-opacity": 1,
              },
              hover: {
                //fill: '#020E3A',
                fillOpacity: 0.8,
              },
              selected: {
                fill: "#000a2e",
              },
              selectedHover: {
                fill: "#000a2e",
                fillOpacity: 0.8,
              },
            },
            focusOn: {
              x: 0.4,
              y: 0.6,
              scale: 1,
            },
            markerStyle: {
              initial: {
                fill: defaultColors.markerColor,
                fillOpacity: 1,
              },
            },
            onRegionLabelShow: (e, el, code) => {
              paises.countries.map((pais) => {
                if (pais.code === code) {
                  el.html(language === "US" ? pais.name_en : pais.name_es);
                }
              });
              markersValue.map((mark) => {
                if (mark.PaisId === code) {
                  el.html(
                    el.html() +
                      ": " +
                      mark.total +
                      " " +
                      this.props.t("shipments")
                  );
                }
              });
            },
          }}
          series={{
            regions: [
              {
                values: RegionValues,
                scale: defaultColors.scaleColors,
                normalizeFunction: "polynomial",
              },
            ],
          }}
          // markers={markers}
          markers={[]}
        />
      );
      this.setState({
        loadingShiptmenMap: false,
        MapShipmentCountry: NewMap,
        titleShipmentForCountry: response.data.data.titleShipmentForCountry,
      });
    } catch (error) {
      console.log("error", error);
    }
  };

  obtieneEventosAtencion = async (EventosAtencion) => {
    // const allowUsers = ["1", "3", "4"];
    // let data = {
    //   Entities: this.props.clients ? JSON.stringify(this.props.clients) : '[0]'
    // };
    //############ INVOCACION COMENTADA ##############
    // let getAttention =
    // allowUsers.includes(this.props._rolId) ?
    //  await Axios.post(`${Services.DASHBOARD.path}dashboard/events`, data)
    // : '';
    let Attention = EventosAtencion;
    // allowUsers.includes(this.props._rolId) ?
    // getAttention.data.data
    //  : [];
    this.setState({ Attention });
  };

  obtieneTendenciasEmbarques = async (data) => {
    let { tendenciaData, maxTendencia } = this.state;
    tendenciaData = [["x", this.props.t("shipments")]];
    data[0].data.map((mes) => {
      tendenciaData.push([mes[0], parseInt(mes[1])]);
      if (parseInt(mes[1]) > maxTendencia) {
        maxTendencia = mes.total;
      }
    });
    this.setState({ tendenciaData, maxTendencia });
  };

  obtieneEstatusEmbarques = (data) => {
    var estatus = [];
    var colorInicial = "#0045F3";
    data.Embarques.map((value) => {
      // if (value.estatus !== 'Creado' && value.estatus !== 'En tránsito a destino') {
      estatus.push({
        nombre: value.estatus,
        total: parseInt(value.total),
        color: colorInicial,
        extra: "",
      });
      colorInicial = this.colores(colorInicial);
      // }
    });
    let Logistics = [
      [
        "Element",
        "Total",
        { role: "style" },
        {
          sourceColumn: 0,
          role: "annotation",
          type: "string",
          calc: "stringify",
        },
      ],
    ];
    try {
      estatus.map((value) => {
        const element = value;
        Logistics.push([
          element.nombre,
          element.total,
          element.color,
          element.extra,
        ]);
      });
      return Logistics;
    } catch (error) {
      return Logistics;
    }
  };

  hex = (c) => {
    var s = "0123456789abcdef";
    var i = parseInt(c);
    if (i == 0 || isNaN(c)) return "00";
    i = Math.round(Math.min(Math.max(0, i), 255));
    return s.charAt((i - (i % 16)) / 16) + s.charAt(i % 16);
  };
  convertToHex = (rgb) => {
    return this.hex(rgb[0]) + this.hex(rgb[1]) + this.hex(rgb[2]);
  };
  trim = (s) => {
    return s.charAt(0) == "#" ? s.substring(1, 7) : s;
  };

  convertToRGB = (hex) => {
    var color = [];
    color[0] = parseInt(this.trim(hex).substring(0, 2), 16);
    color[1] = parseInt(this.trim(hex).substring(2, 4), 16);
    color[2] = parseInt(this.trim(hex).substring(4, 6), 16);
    return color;
  };
  colores = (startHex) => {
    var start =
      this.convertToRGB(startHex); /* The beginning of your gradient */
    var end = this.convertToRGB("#FFFFFF"); /* The end of your gradient */

    var alpha = 0.7; /* Alpha blending amount */
    var c = [];

    // for (var i = 0; i < len; i++) {

    c[0] = start[0] * alpha + (1 - alpha) * end[0];
    c[1] = start[1] * alpha + (1 - alpha) * end[1];
    c[2] =
      start[2] * alpha +
      (1 - alpha) * end[2]; /* Set the background color of this element */
    // console.log("convertToHex", this.convertToHex(c));
    // start = c;
    // }
    return "#" + this.convertToHex(c);
  };

  obtieneTotales = (data) => {
    var PedidosActivos = data.totales[0].Total;
    var EmbarquesActivos = data.totales[1].Total;
    var ConsolidadosActivos = data.totales[2].Total;
    var EmbarquesPrioritarios = data.totales[3].Total;
    var totales = {};

    totales = {
      PedidosActivos,
      EmbarquesActivos,
      ConsolidadosActivos,
      EmbarquesPrioritarios,
    };
    return totales;
  };

  /*=============================================
  =            Life Cicle Component             =
  =============================================*/

  componentDidUpdate = (nextProps) => {
    // console.log("nextProps", nextProps);
    // if (this.props.lang != nextProps.lang) {
    //   i18n.changeLanguage(nextProps.lang)
    // }
  };
  componentDidMount = () => {
    let details = navigator.userAgent;
    let regexp = /android|iphone|kindle|ipad/i;
    let isMobileDevice = regexp.test(details);
    const sessionLang = session.getItem("lang");
    let newStates = {
      isMovil: isMobileDevice,
    };
    if (sessionLang && sessionLang !== this.props.lang) {
      newStates.language = sessionLang;
    }
    this.setState(newStates, () => this.getInfoDashBoard());
    document.getElementById("body").className = "layout-fixed"; // !changed for nothing
  };

  IconLabel = ({ color, label }) => (
    <>
      <i className="fas fa-circle m-1" style={{ color }}></i>
      <span className="label-graphic">{label}</span>
    </>
  );

  TooltipContent = ({ value }) => (
    <div className="row" style={cardTooltipStyle}>
      <div className="col-12">
        <h5>{Number(value).toLocaleString("en-US")}</h5>
      </div>
    </div>
  );

  /*=============================================
  =            Render Method                    =
  =============================================*/

  render() {
    const {
      estatusEmbarques,
      totales,
      tendenciaData,
      loadingTrends,
      loadingTotals,
      fullLoader,
      optionShipmentForCountry,
      optionShipmentDefault,
      MapShipmentCountry,
      loadingShiptmenMap,
      isMovil,
      colors,
      ModoTransporte,
      shipmentForCountrySelected,
    } = this.state;
    const { classes } = this.props;

    return (
      <>
        <>
          <Loader hidden={fullLoader} />
          <ContentWrapper>
            <div className="content-heading">
              <span className="icon-dashboard icon-header" />
              {this.props.t("dashboard")}
              <div className="euro-return-tittle">
                <span className="label-euro bold pr-4">
                  {this.props.t("dashboard_label_current_last_year")}
                </span>
              </div>
            </div>
            <Row>
              <CardsTotals
                image={
                  <span className="icon-active-orders icons-cards-totals"></span>
                }
                xl={3}
                md={6}
                sm={12}
                loading={loadingTotals}
                total={totales.PedidosActivos}
                title={this.props.t("active_orders")}
                propertiesIcon={
                  "col-3 d-flex align-items-center rounded-left2 "
                }
                propertiesTitle={"col-9 rounded-right2 endPosition"}
                data-testid="active_orders_test"
                colorClass="bg-maritimo"
              />
              <CardsTotals
                image={
                  <span className="icon-active-shipments icons-cards-totals"></span>
                }
                xl={3}
                md={6}
                sm={12}
                loading={loadingTotals}
                total={totales.EmbarquesActivos}
                title={this.props.t("active_shipments")}
                propertiesIcon={
                  "col-3 d-flex align-items-center rounded-left2  "
                }
                propertiesTitle={"col-9 rounded-right2 endPosition"}
                data-testid="active_shipments_test"
                colorClass="bg-maritimo"
              />
              <CardsTotals
                image={
                  <span className="icon-active-consols icons-cards-totals"></span>
                }
                xl={3}
                md={6}
                sm={12}
                loading={loadingTotals}
                total={totales.ConsolidadosActivos}
                title={this.props.t("active_consols")}
                propertiesIcon={
                  "col-3 d-flex align-items-center rounded-left2 "
                }
                propertiesTitle={"col-9 rounded-right2 endPosition"}
                data-testid="active_consols_test"
                colorClass="bg-maritimo"
              />
              <CardsTotals
                image={
                  <span className="icon-priority-shipments icons-cards-totals"></span>
                }
                xl={3}
                md={6}
                sm={12}
                loading={loadingTotals}
                total={totales.EmbarquesPrioritarios}
                title={this.props.t("priority_shipments")}
                propertiesIcon={
                  "col-3 d-flex align-items-center rounded-left2 "
                }
                propertiesTitle={"col-9 rounded-right2 endPosition"}
                data-testid="priority_shipments_test"
                colorClass="bg-tcc"
              />
            </Row>
            <Row>
              <div className="col-xs-12 col-md-6 col-lg-6">
                <div className="card myCard equalsWidth">
                  <div className="card-header">
                    <div className="card-title">
                      {this.props.t("shipments_perlast")}
                    </div>
                  </div>
                  <div className="card-body">
                    {loadingTrends ? (
                      <FullLoader />
                    ) : (
                      <Chart
                        className="valueTable"
                        chartType="BarChart"
                        loader={<div>Loading Chart</div>}
                        data={estatusEmbarques}
                        options={chartOptions}
                        rootProps={{ "data-testid": "6" }}
                      />
                    )}
                  </div>
                </div>
              </div>
              <div className="col-xs-12 col-md-6 col-lg-6 ">
                <div className="card myCard equalsWidth">
                  <div className="card-header">
                    <div className="card-title">
                      {this.props.t("shipment_tendency")}
                    </div>
                  </div>
                  <div className="card-body">
                    {loadingTrends ? (
                      <FullLoader />
                    ) : (
                      <div id="chartDashboard">
                        <Chart
                          className={"valueTable"}
                          chartType="LineChart"
                          loader={<div>Loading Chart</div>}
                          data={tendenciaData}
                          options={chartOptionsLine}
                          rootProps={{ "data-testid": "1" }}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="col-xs-12 col-md-6 col-lg-6">
                <div className="card myCard equalsWidth">
                  <div className="card-header">
                    <div className="card-title">
                      {this.props.t("last_year_shipments")}
                    </div>
                  </div>
                  <div className="card-body">
                    {isMovil &&
                      ModoTransporte?.data &&
                      ModoTransporte.data.length > 0 && (
                        <div className="d-flex justify-content-center align-items-center">
                          {ModoTransporte.data.map((item, index) => (
                            <this.IconLabel
                              key={index}
                              color={colors[index]}
                              label={item.label}
                            />
                          ))}
                        </div>
                      )}
                    <div
                      style={{
                        position: "relative",
                        height: "300px",
                        width: "100%",
                      }}
                    >
                      {ModoTransporte?.data &&
                      ModoTransporte.data.length > 0 ? (
                        <ResponsivePie
                          data={ModoTransporte.data}
                          margin={{ top: 20, right: 20, bottom: 50, left: 20 }}
                          pixelRatio={1}
                          startAngle={-18}
                          innerRadius={0.5}
                          padAngle={0.7}
                          colors={colors}
                          borderColor={{
                            from: "color",
                            modifiers: [["darker", "0"]],
                          }}
                          legends={isMovil ? [] : [legendSettings]}
                          tooltip={({ datum }) => (
                            <this.TooltipContent value={datum.value} />
                          )}
                          slicesLabelsSkipAngle={20}
                          arcLabelsTextColor="#fff"
                          arcLabelsSkipAngle={20}
                          enableArcLinkLabels={false}
                          arcLabel={(e) =>
                            Number(e.value).toLocaleString("en-US")
                          }
                        />
                      ) : (
                        <FullLoader />
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xs-12 col-md-6 col-lg-6">
                <div className="card myCard equalsWidth">
                  <div className="card-header">
                    <div className="card-title row">
                      <div className="col-xs-12 col-md-9 col-lg-9">
                        {this.props.t(
                          shipmentForCountrySelected !== 1
                            ? "last_year_shipment_destination"
                            : "last_year_shipment_origin"
                        )}
                      </div>
                      <div className="col-xs-12 col-md-3 col-lg-3">
                        <Autocomplete
                          closeText={false}
                          openText={false}
                          disableClearable={true}
                          style={{ marginTop: "6px" }}
                          id="size-small-standard"
                          className="input-euro"
                          size="small"
                          ListboxProps={{
                            sx: { fontSize: 12 },
                          }}
                          sx={{
                            "& .MuiAutocomplete-input, & .MuiInputLabel-root": {
                              fontSize: 12,
                            },
                          }}
                          options={optionShipmentForCountry}
                          defaultValue={optionShipmentDefault}
                          onChange={this.handleChangeDrop("shipmentForCountry")}
                          renderInput={(params) => {
                            return (
                              <TextField
                                {...params}
                                variant="standard"
                                className={classes.textfield}
                              />
                            );
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    {loadingShiptmenMap ? <ShipmentMap /> : MapShipmentCountry}
                  </div>
                </div>
              </div>
            </Row>
          </ContentWrapper>
        </>
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  clients: state.header.clients,
  lang: state.header.lang,
});
const mapDispatchToProps = () => ({});

export default withNamespaces()(
  withStyles(useStyles)(connect(mapStateToProps, mapDispatchToProps)(Home))
);
